<template>
  <div class="app-container">
    <PageTitle title="订单列表" ref="pageTitle" v-model="listQuery.city" @onChange="changeCity" />
    <div class="filter-container">
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.source"
        placeholder="所属平台"
        @change="changeSource"
      >
        <el-option
          v-for="item in platform_options"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入订单编号"
        v-model="listQuery.ota_sn"
        @change="handleOtaSn"
      ></el-input>
      <el-select
        clearable
        v-model="project_ids"
        filterable
        multiple
        collapse-tags
        placeholder="请选择项目名称"
        style="width: 200px; margin-right: 10px; height: 32px"
        @change="changeProject"
      >
        <el-option
          v-for="item in project_options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div style="display: inline-block; margin-right: 10px; vertical-align: top">
        <span style="font-size: 14px; color: #606266; line-height: 32px">标记：</span>
        <el-select
          clearable
          v-model="remark_color"
          placeholder="请选择"
          style="width: 120px; height: 32px"
          @change="changeRemarkColor"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in remarkColorOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
            <div style="display: flex; align-items: center">
              <div
                :style="{
                  width: '14px',
                  height: '14px',
                  backgroundColor: item.hex,
                  marginRight: '8px',
                  borderRadius: '2px',
                  border: item.hex === '#FFFFFF' ? '1px solid #dcdfe6' : 'none'
                }"
              ></div>
              <span>{{ item.label }}</span>
            </div>
          </el-option>
        </el-select>
      </div>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入手机号"
        v-model="listQuery.contact_mobile"
        @change="handleMobile"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入姓名"
        v-model="listQuery.contact_name"
        @change="handleContactName"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入产品名称"
        v-model="listQuery.product_name"
        @change="handleProductName"
      ></el-input>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.assign_status"
        placeholder="请选择派单状态"
        @change="handleAssignStatus"
      >
        <el-option label="未派单" :value="1"></el-option>
        <el-option label="已派单" :value="2"></el-option>
      </el-select>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.ticket_assign_status"
        placeholder="请选择派发状态"
        @change="handleTicketAssignStatus"
      >
        <el-option label="未派发" :value="0"></el-option>
        <el-option label="已派发" :value="1"></el-option>
      </el-select>
      <el-select
        clearable
        multiple
        collapse-tags
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.order_status"
        placeholder="请选择订单状态"
        @change="handleOrderStatus"
      >
        <template v-for="(item, index) in orderStatusOptions">
          <el-option :key="index" :label="item" :value="index" v-if="index > 0"></el-option>
        </template>
      </el-select>
      <el-date-picker
        style="margin-right: 10px"
        v-model="listQuery.use_date"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="出行开始日期"
        end-placeholder="出行结束日期"
        @change="handleUseDate"
      >
      </el-date-picker>

      <TimeSelect
        @changeInterval="handleInterval"
        v-model="listQuery.interval_time"
        customStyle="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
      />

      <el-date-picker
        v-model="listQuery.pay_time"
        type="daterange"
        range-separator="至"
        start-placeholder="订单开始时间"
        end-placeholder="订单结束时间"
        style="margin: 0 10px 10px 0; vertical-align: middle; width: 330px"
        @change="handlePayTime"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <!-- <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.is_assign_guide"
        placeholder="是否是分派导游"
      >
        <el-option label="是" :value="1"></el-option>
        <el-option label="否" :value="0"></el-option>
      </el-select> -->
      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" type="primary" @click="$refs.addOrder.handleAddOrder()"
        >手动录入订单</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-download" @click="handleExport"
        >导出</el-button
      >
    </div>
    <el-button
      v-if="consumeBtnShow"
      type="primary"
      size="mini"
      @click="handleConsumeBatch()"
      style="margin-bottom: 10px"
      >批量核单</el-button
    >
    <Table :data="list" :columns="columns" :loading="listLoading" @changeSelect="changeSelect">
      <template v-slot:selection>
        <el-table-column width="50" align="center" type="selection" :selectable="checkSelectable">
        </el-table-column>
      </template>
      <template v-slot:remark>
        <el-table-column label="备注" width="160">
          <template slot-scope="scope">
            <p
              :style="{
                backgroundColor: getRemarkHexColor(scope.row.remark_color || 'red'),
                width: '30px',
                height: '30px',
                cursor: 'pointer'
              }"
              @click="
                $refs.remark.handleRemark(
                  scope.row.sn,
                  scope.row.remark,
                  scope.row.remark_color || 'red'
                )
              "
            ></p>
            <p>{{ scope.row.remark }}</p>
          </template>
        </el-table-column>
      </template>
      <template v-slot:product>
        <el-table-column label="产品名称" width="200">
          <template slot-scope="scope">
            <p>{{ scope.row.ota_sn }}</p>
            <p>{{ scope.row.product_name }}</p>
            <!-- {{ scope.row.source == 'XC' ? '携程' : '' }}  -->
          </template>
        </el-table-column>
      </template>
      <template v-slot:source>
        <el-table-column label="所属平台" width="140" align="center">
          <template slot-scope="scope">
            {{ $platform[scope.row.source] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:trip_type>
        <el-table-column label="订单类型" width="80" align="center">
          <template slot-scope="scope">
            {{ ['', '拼团', '包团'][scope.row.trip_type] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:interval_time>
        <el-table-column label="场次" width="100" align="center">
          <template slot-scope="scope"> {{ scope.row.interval_time }}场 </template>
        </el-table-column>
      </template>
      <template v-slot:contact>
        <el-table-column label="联系人" width="150" align="center">
          <template slot-scope="scope">
            {{ scope.row.contact.name }}｜{{ scope.row.contact.mobile }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:pay_time>
        <el-table-column label="下单时间" width="160" align="center">
          <template slot-scope="scope">
            <el-link type="info" :underline="false">{{ scope.row.pay_time }}</el-link>
          </template>
        </el-table-column>
      </template>

      <template v-slot:order_status>
        <el-table-column label="订单状态" width="100" align="center">
          <template slot-scope="scope">
            {{ orderStatusOptions[scope.row.order_status] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:assign_status>
        <el-table-column label="派单状态" width="80" align="center">
          <template slot-scope="scope">
            {{ ['', '未派单', '已派单'][scope.row.assign_status] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:ticket_assign_status>
        <el-table-column label="门票派发状态" width="120" align="center">
          <template slot-scope="scope">
            {{ ['未派发', '已派发'][scope.row.ticket_assign_status] }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:action>
        <el-table-column label="操作" minWidth="260" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="$refs.drawer.handleDetail(scope.row.sn)"
              >订单详情</el-button
            >
            <el-button
              v-if="scope.row.can_edit"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="$refs.edit.handleEdit(scope.row.sn)"
            />
            <el-button
              v-if="scope.row.order_status == 1"
              type="primary"
              size="mini"
              @click="$refs.consume.handleConsume(scope.row.sn, scope.row.can_consume)"
              >核单</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="
                $refs.remark.handleRemark(
                  scope.row.sn,
                  scope.row.remark,
                  scope.row.remark_color || 'red'
                )
              "
              >备注</el-button
            >
            <el-button
              type="primary"
              size="mini"
              v-if="scope.row.has_ticket_record"
              @click="$refs.record.handleRecord(scope.row.sn)"
              >购票记录</el-button
            >
            <el-button
              type="primary"
              size="mini"
              v-if="scope.row.can_cancel"
              @click="handleCancel(scope.row.sn)"
              >取消订单</el-button
            >

            <el-button
              type="primary"
              size="mini"
              @click="closeOrder(scope.row.sn)"
              v-if="scope.row.can_close"
              >关闭订单</el-button
            >
            <el-button
              type="primary"
              size="mini"
              v-if="scope.row.can_assign_ticket"
              @click="$refs.assignTicket.handleAssignTicket(scope.row)"
              >派发门票</el-button
            >
            <el-button
              v-if="scope.row.source == 'ZWY'"
              type="primary"
              size="mini"
              @click="downLoadPdf(scope.row)"
              >下载确认单</el-button
            >
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
    <Edit ref="edit" />
    <Consume ref="consume" />
    <OrderDrawer ref="drawer" />
    <Remark ref="remark" />
    <Record ref="record" />
    <AddOrder ref="addOrder" />
    <AssignTicket ref="assignTicket" />
  </div>
</template>

<script>
import { getList as getProjectList } from '@/api/projects'
import AssignTicket from './components/AssignTicket.vue'
import {
  getList,
  consumeBatch,
  cancelOrder,
  exportOrders,
  closeOrder,
  downloadPdf
} from '@/api/orders'
import PageTitle from '@/components/PageTitle'
import Edit from './components/Edit'
import Consume from './components/Consume'
import TimeSelect from '@/components/TimeSelect'
import OrderDrawer from '@/components/OrderDrawer'
import Remark from './components/Remark'
import Record from './components/Record'
import AddOrder from './components/AddOrder'
import { PLATFORM_OPTIONS } from '../../utils/platform'
export default {
  name: 'OrdersIndex',
  components: {
    PageTitle,
    Edit,
    Consume,
    TimeSelect,
    OrderDrawer,
    Remark,
    Record,
    AddOrder,
    AssignTicket
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      project_ids: [],
      listQuery: {
        page: 1,
        size: 10,
        city: '',
        source: '',
        ota_sn: '',
        contact_mobile: '',
        contact_name: '',
        product_name: '',
        assign_status: '',
        order_status: '',
        use_date: '',
        use_date_start: '',
        use_date_end: '',
        interval_time: '',
        pay_time: '',
        pay_time_start: '',
        pay_time_end: '',
        project_ids: '',
        // project_name: '',
        ticket_assign_status: '',
        remark_color: ''
      },
      remark_color: '',
      remarkColorOptions: [
        { value: 'red', hex: '#FF0000', label: '红色' },
        { value: 'green', hex: '#00B050', label: '绿色' },
        { value: 'gray', hex: '#BFBFBF', label: '灰色' },
        { value: 'blue', hex: '#0070C0', label: '蓝色' },
        { value: 'yellow', hex: '#FFFF00', label: '黄色' }
      ],
      platform_options: PLATFORM_OPTIONS,
      consumeBtnShow: false,
      sn_list: [],
      project_options: [],
      columns: [
        { type: 'selection', slot: 'selection' },
        // {
        //   type: 'index',
        //   align: 'center',
        //   label: '序号',
        //   width: '50'
        // },
        // {
        //   label: '订单编号',
        //   width: '150',
        //   prop: 'ota_sn'
        // },
        {
          label: '备注',
          slot: 'remark'
          // width: '160',
          // prop: 'remark',
          // showOverflowTooltip: true
        },

        {
          label: '产品名称',
          slot: 'product'
          // width: '200',
          // prop: 'product_name',
          // showOverflowTooltip: true
        },
        {
          label: '套餐名称',
          width: '160',
          prop: 'package_name',
          showOverflowTooltip: true
        },
        {
          label: '数量',
          width: '80',
          prop: 'user_num',
          align: 'center'
        },

        {
          label: '总金额',
          width: '100',
          prop: 'price',
          align: 'center'
        },
        {
          label: '出发日期',
          width: '120',
          prop: 'use_date',
          align: 'center'
        },
        {
          label: '订单类型',
          slot: 'trip_type'
        },
        {
          label: '场次',
          slot: 'interval_time'
        },
        {
          label: '联系人',
          slot: 'contact'
        },
        {
          label: '项目',
          width: '140',
          prop: 'project_name',
          showOverflowTooltip: true
        },
        {
          label: '订单状态',
          slot: 'order_status'
        },
        {
          label: '派单状态',
          slot: 'assign_status'
        },
        {
          label: '门票派发状态',
          slot: 'ticket_assign_status'
        },
        {
          label: '所属平台',
          slot: 'source'
        },

        // {
        //   label: '单价',
        //   width: '100',
        //   prop: 'unit_price',
        //   align: 'center'
        // },

        // {
        //   label: '项目',
        //   width: '120',
        //   prop: 'project_name',
        //   showOverflowTooltip: true
        // },

        {
          label: '下单时间',
          slot: 'pay_time'
        },

        {
          label: '操作',
          slot: 'action'
        }
      ],
      orderStatusOptions: [
        '',
        '待核单',
        '已核单',
        '已取消',
        '买家已付款',
        '卖家已发货',
        '交易成功',
        '交易关闭',
        '部分退款'
      ]
    }
  },

  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
    this.fetchData()
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      const query = { ...this.listQuery }

      query.order_status = query.order_status.toString()

      getList(query).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        if (query.use_date_start && query.use_date_end) {
          query.use_date = [query.use_date_start, query.use_date_end]
        }
        if (query.pay_time_start && query.pay_time_end) {
          query.pay_time = [query.pay_time_start, query.pay_time_end]
        }
        this.listLoading = false
      })
    },
    changeSource(e) {
      this.listQuery.source = e
      this.fetchData()
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
      this.handleFilter()
    },
    /**
     * @description: 选择项目名称
     * @param {*} e
     * @return {*}
     */
    changeProject(value) {
      let list = this.project_options.filter((item) => value.includes(item.id))
      console.log(list, value)
      this.project_ids = value
      this.listQuery.project_ids = value.join(',')
      this.user_limit = list.length > 0 ? list[0].user_limit : undefined
      this.handleFilter()
    },
    changeRemarkColor(value) {
      this.listQuery.remark_color = value || ''
      this.handleFilter()
    },
    handleOtaSn(e) {
      this.listQuery.ota_sn = e
      this.handleFilter()
    },
    handleMobile(e) {
      this.listQuery.contact_mobile = e
      this.handleFilter()
    },
    handleContactName(e) {
      this.listQuery.contact_name = e
      this.handleFilter()
    },
    handleProductName(e) {
      this.listQuery.product_name = e
      this.handleFilter()
    },
    handleAssignStatus(e) {
      this.listQuery.assign_status = e
      this.handleFilter()
    },
    handleTicketAssignStatus(e) {
      this.listQuery.ticket_assign_status = e
      this.handleFilter()
    },
    handleOrderStatus(e) {
      this.listQuery.order_status = e
      this.handleFilter()
    },
    handleUseDate(e) {
      if (e) {
        this.listQuery.use_date_start = e[0]
        this.listQuery.use_date_end = e[1]
      } else {
        this.listQuery.use_date_start = ''
        this.listQuery.use_date_end = ''
      }
      this.handleFilter()
    },
    handleInterval(e) {
      this.listQuery.interval_time = e
      this.handleFilter()
    },
    handlePayTime(e) {
      if (e) {
        this.listQuery.pay_time_start = e[0]
        this.listQuery.pay_time_end = e[1]
      } else {
        this.listQuery.pay_time_start = ''
        this.listQuery.pay_time_end = ''
      }
      this.handleFilter()
    },

    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      // delete this.listQuery.use_date
      // delete this.listQuery.pay_time
      this.fetchData()
    },
    /**
     * @description:
     * @return {*}
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: 1,
        ota_sn: '',
        contact_mobile: '',
        contact_name: '',
        product_name: '',
        assign_status: '',
        order_status: '',
        use_date: '',
        use_date_start: '',
        use_date_end: '',
        interval_time: '',
        pay_time: '',
        pay_time_start: '',
        pay_time_end: '',
        ticket_assign_status: '',
        remark_color: ''
      }
      this.remark_color = ''
      this.fetchData()
    },
    handleExport() {
      const query = { ...this.listQuery, order_status: this.listQuery.order_status.toString() }
      if (query.pay_time && query.pay_time.length) {
        query.pay_time_start = query.pay_time[0]
        query.pay_time_end = query.pay_time[1]
      }
      exportOrders(query).then((res) => {
        import('@/vendor/Export2Excel').then((excel) => {
          excel.export_json_to_excel({
            header: res.data.header,
            data: res.data.data,
            filename: '订单列表'
          })
        })
      })
    },
    /**
     * @description: 下载确认单
     * @param {*} sn
     * @return {*}
     */
    downLoadPdf(row) {
      downloadPdf(row.sn)
        .then((res) => {
          const blob = res && res.data ? res.data : null
          if (!blob) return
          // 尝试从响应头中解析文件名
          let filename = `${row.sn}.pdf`
          const cd =
            res.headers &&
            (res.headers['content-disposition'] || res.headers['Content-Disposition'])
          if (cd) {
            const utf8Match = /filename\*=?(?:UTF-8''|)([^;\n]+)/i.exec(cd)
            const asciiMatch = /filename="?([^";]+)"?/i.exec(cd)
            if (utf8Match && utf8Match[1]) {
              try {
                filename = decodeURIComponent(utf8Match[1].trim())
              } catch (e) {
                filename = utf8Match[1].trim()
              }
            } else if (asciiMatch && asciiMatch[1]) {
              filename = asciiMatch[1].trim()
            }
          }
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch(() => {})
    },
    /**
     * @description: 订单详情
     * @param {*} sn
     * @return {*}
     */
    handleDetail(sn, can_consume) {
      this.$router.push({ path: `/orders/detail/${sn}`, query: { can_consume } })
    },

    /**
     * @description: 判断是否可选
     * @return {*}
     */
    checkSelectable(row) {
      return row.order_status == 1 && !!row.can_consume
    },
    /**
     * @description: 选择行
     * @return {*}
     */
    changeSelect(e) {
      this.consumeBtnShow = !!e.length > 0
      this.sn_list = e.map((item) => item.sn)
    },
    /**
     * @description: 批量核单
     * @return {*}
     */
    handleConsumeBatch() {
      const _this = this
      _this
        .$confirm('确认批量核单当前项目么？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          consumeBatch({ sn_list: _this.sn_list }).then(() => {
            _this.$notify({
              title: '成功',
              message: '批量核单成功',
              type: 'success'
            })
            _this.fetchData()
          })
        })
        .catch(() => {})
    },
    /**
     * @description: 取消订单
     * @return {*}
     */
    handleCancel(sn) {
      const _this = this
      _this
        .$confirm('是否确认取消该订单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          cancelOrder(sn).then(() => {
            _this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            _this.fetchData()
          })
        })
        .catch(() => {})
    },
    getRemarkHexColor(colorStr) {
      const colorMap = {
        red: '#FF0000',
        green: '#00B050',
        gray: '#BFBFBF',
        blue: '#0070C0',
        yellow: '#FFFF00'
      }
      return colorMap[colorStr] || colorStr || '#FF0000'
    },
    // getRemarkColor(row) {
    //   if (['yellow', 'blue'].includes(row.remark_color)) {
    //     return row.remark_color
    //   }
    //   if (row.order_status == 7) {
    //     return 'gray'
    //   }
    //   if (row.assign_status == 2) {
    //     return 'green'
    //   }
    //   return 'red'
    // },
    closeOrder(sn) {
      const _this = this
      _this
        .$confirm('是否确认关闭该订单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          closeOrder(sn).then(() => {
            _this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            _this.fetchData()
          })
        })
        .catch(() => {})
    },
    /**
     * @description: 派发门票
     */
    handleAssignTicket(sn) {
      console.log(sn)
    }
  }
}
</script>
<style scoped>
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
.el-button {
  margin-bottom: 5px;
  margin-left: 0;
  margin-right: 5px;
}
</style>
